import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';

import PlaygroundNodes from './nodes/PlaygroundNodes';
import PlaygroundEditorTheme from './themes/PlaygroundEditorTheme';
import ContentEditable from './ui/ContentEditable';

import EditorStateUpdatePlugin from './plugins/EditorStateUpdatePlugin';

const EditorReadOnly = ({ preLoadedState, additionalClassName }) => {
	const initialConfig = {
		editorState: preLoadedState || undefined,
		namespace: 'Comeon',
		nodes: [...PlaygroundNodes],
		onError: error => {
			throw error;
		},
		theme: PlaygroundEditorTheme,
		editable: false
	};

	return (
		<LexicalComposer initialConfig={initialConfig}>
			<div className={`editor-container ${additionalClassName}`}>
				<RichTextPlugin
					contentEditable={
						<div className="editor-scroller">
							<div className="editor">
								<ContentEditable placeholder="" className="editor-input" />
							</div>
						</div>
					}
					ErrorBoundary={LexicalErrorBoundary}
				/>
				<EditorStateUpdatePlugin editorState={preLoadedState} />
			</div>
		</LexicalComposer>
	);
};

export default EditorReadOnly;
